module.exports = __webpack_public_path__ + "img/dropdown-search-nissan.a4e904f9.png";